import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 rounded-full" data-testid="privacy-back-btn">
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>
        <h1 className="text-4xl sm:text-5xl font-bold text-secondary mb-6">Privacy Policy</h1>
        <div className="space-y-5 text-foreground/80 text-base leading-relaxed">
          <p>Last updated: {new Date().getFullYear()}</p>
          <p>Revivedu ("we", "us") respects your privacy. This placeholder policy explains, in plain language, how we handle information you share with us while using revivedu.com.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Information we collect</h2>
          <p>We collect the details you provide when you create an account (your name and email) and the activity preferences you enter (such as your child's age, interests and chosen subjects) to generate personalized learning activities.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">How we use it</h2>
          <p>Your information is used solely to create and improve the learning activities and reports we provide to you. We do not sell your personal data.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Children's data</h2>
          <p>Accounts are held by parents and guardians. Any information about a child is entered by the parent and used only to tailor learning content.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Contact</h2>
          <p>Questions? Email us at <a className="text-primary font-semibold hover:underline" href="mailto:hi@revivedu.com">hi@revivedu.com</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
